import React from 'react';
import { 
  Box, 
  Typography, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem
} from '@mui/material';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ImageIcon from '@mui/icons-material/Image';
import LinkIcon from '@mui/icons-material/Link';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const PostTypeSelector = ({ postType, handlePostTypeChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Preview Settings
      </Typography>
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel id="post-type-label">Post Type</InputLabel>
        <Select
          labelId="post-type-label"
          id="post-type"
          value={postType}
          label="Post Type"
          onChange={handlePostTypeChange}
          size="small"
          defaultValue="text-only"
        >
          <MenuItem value="text-only">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextFieldsIcon sx={{ mr: 1 }} fontSize="small" />
              Text Only
            </Box>
          </MenuItem>
          <MenuItem value="with-media">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ImageIcon sx={{ mr: 1 }} fontSize="small" />
              With Image/Video
            </Box>
          </MenuItem>
          <MenuItem value="with-link">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LinkIcon sx={{ mr: 1 }} fontSize="small" />
              With Link/Poll
            </Box>
          </MenuItem>
          <MenuItem value="promoted">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <MonetizationOnIcon sx={{ mr: 1 }} fontSize="small" />
              Promoted Post
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default PostTypeSelector;